import { useEffect, useState } from 'react';
import { axiosPrivate } from '../../../api/axios';
import axios from '../../../api/axios';
import useAuth from '../../../hooks/useAuth';
import imageCompression from 'browser-image-compression';
import { Link } from 'react-router-dom';

//Components
import LoadingSpinner from '../../loadingSpinner/LoadingSpinner';
import Error from '../Error';

//Translation
import { useTranslation } from 'react-i18next';

//Styling

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faEdit, faRotateLeft, faTrash } from "@fortawesome/free-solid-svg-icons";
import '../../../css/HomeAdmin.css'

export default function HomeAdmin({ isNavOpen }) {
  const { t } = useTranslation();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const { auth } = useAuth();
  const isAdmin = auth?.roles?.includes('Admin');
  const MIN_TEST_ID = Number(process.env.REACT_APP_TEST_USER_MIN_ID || 0);
  const isTestUser = auth?.userId <= MIN_TEST_ID;
  const canEditSchool = auth?.userId <= 2;


  const [school, setSchool] = useState(null);
  const [subscriptionsData, setSubscriptionData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [logoUrl, setLogoUrl] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [showConfirmResetAll, setShowConfirmResetAll] = useState(false);
  const [showResetSuccess, setShowResetSuccess] = useState(false);
  const [blockedAction, setBlockedAction] = useState(null);


  // Media editing
  const [mediaModalVisible, setMediaModalVisible] = useState(false);
  const [mediaType, setMediaType] = useState(null); // 'logo', 'video', 'image'
  const [selectedMediaFile, setSelectedMediaFile] = useState(null);
  const [mediaPreviewUrl, setMediaPreviewUrl] = useState(null);
  const [mediaError, setMediaError] = useState('');

  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'];
  const videoExtensions = ['mp4', 'webm', 'ogg'];

  const DemoBlockedMessage = ({ message, onClose }) => (
    <div className="demo-blocked-message">
      <span>{message}</span>
      <button
        className="demo-blocked-close"
        onClick={onClose}
        aria-label="Close"
      >
        ✕
      </button>
    </div>
  );


  useEffect(() => {
    const fetchSubscriptionData = async () => {
      try {
        const response = await axios.get('/school/subscriptions-data');

        if (response.data)

          setSubscriptionData(response.data);

      } catch (err) {
        console.error('Failed to fetch subscriptions', err);
      }
    };

    fetchSubscriptionData();
  }, []);

  const handleMediaClick = (type) => {

    if (isTestUser || !canEditSchool) {
      setBlockedAction(`edit-${type}`);
      return;
    }


    setMediaError('');
    setSelectedMediaFile(null);
    setMediaPreviewUrl(null);
    setMediaType(type);
    setMediaModalVisible(true);
  };

  const handleDeleteMedia = async (type) => {
    if (!window.confirm(`Delete this ${type}?`)) return;

    try {
      const response = await axiosPrivate.delete('/school/delete-media', {
        data: { mediaType: type, dnzify_url: school.dnzify_url },
      });

      // console.log('Delete success:', response.data);

      if (type === 'logo') setLogoUrl(null);
      else if (type === 'video') setVideoUrl(null);
      else if (type === 'image') setImageUrl(null);
    } catch (err) {
      console.error(t('homeAdmin.error.failedToDelete'), err);
      alert(t('homeAdmin.error.failedToDelete'));
    }
  };


  const handleMediaFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // const allowedTypes = mediaType === 'video'
    //   ? videoExtensions.map(ext => `video/${ext}`)
    //   : imageExtensions.map(ext => `image/${ext}`);

    // if (!allowedTypes.some(t => file.type.includes(t))) {
    //   setMediaError(`Unsupported file type for ${mediaType}`);
    //   return;
    // }

    //To work in iphone

    const fileName = file.name.toLowerCase();
    const mime = file.type.toLowerCase();

    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'heic', 'heif'];
    const videoExts = ['mp4', 'mov', 'webm', 'ogg'];

    const isImage =
      imageExts.some(ext => fileName.endsWith(`.${ext}`)) ||
      mime.startsWith('image/');

    const isVideo =
      videoExts.some(ext => fileName.endsWith(`.${ext}`)) ||
      mime.startsWith('video/');

    if (mediaType === 'image' && !isImage) {
      setMediaError(t('homeAdmin.error.unsupportedImage'));
      return;
    }

    if (mediaType === 'video' && !isVideo) {
      setMediaError(t('homeAdmin.error.unsupportedVideo'));
      return;
    }


    let fileToUpload = file;

    if (mediaType !== 'video') {
      try {
        const options = {
          maxSizeMB: 0.1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
          fileType: 'image/webp',
        };
        const compressedBlob = await imageCompression(file, options);

        // Wrap Blob in File with proper name
        const fileName = `${school.dnzify_url}.webp`; // you can use dnzify_url for filename
        fileToUpload = new File([compressedBlob], fileName, { type: compressedBlob.type });

        setMediaPreviewUrl(URL.createObjectURL(fileToUpload));
      } catch (err) {
        console.error(err);
        setMediaError('Failed to process image');
        return;
      }
    } else {
      setMediaPreviewUrl(URL.createObjectURL(file));
    }

    setSelectedMediaFile(fileToUpload);
  };



  const handleColorChange = (colorField, newValue) => {

    if (isTestUser || !canEditSchool) {
      setBlockedAction(`color-${colorField}`);
      return;
    }

    setSchool(prev => ({ ...prev, [colorField]: newValue }));
    setSaving(true);

    // console.log(newValue)

    // Send update to backend
    axiosPrivate.put('/school/update', {
      field: colorField,
      value: newValue,
      school_id: school.school_id
    })
      .then(() => setSaving(false))
      .catch((err) => {
        console.error('Failed to update color:', err);
        setSaving(false);
      });
  };

  const hardcodedDefaults = {
    color_0: '#000000',
    color_1: '#FFFFFF',
    color_2: '#FF0000',
    color_3: '#8B0000',
    color_6: '#00008B',
    color_7: '#000000',
    color_9: '#808080',
    color_10: '#F4F4F4',
    color_11: '#999999',
    color_12: '#ADD8E6',
    color_13: '#0056b3',
    color_14: '#FFFFFF',
    color_100: '#FFFFFF',
    color_200: '#FFFFFF',
    color_201: '#000000',
    color_202: '#000000',
    color_203: '#FFFFFF',
    color_300: '#FFFFFF',
    color_301: '#FFFFFF',
    color_302: '#000000',
    color_400: '#000000',
    color_401: '#666666',
    color_500: '#F9F9F9'
  };



  const handleResetColor = (colorField) => {

    if (isTestUser || !canEditSchool) {
      setBlockedAction(`reset-color-${colorField}`);
      return;
    }

    const defaultColor = hardcodedDefaults[colorField];
    if (!defaultColor) return;

    handleColorChange(colorField, defaultColor);
  };

  const handleResetAllColors = async () => {
    setSaving(true);

    try {
      // Send all color updates in parallel
      const updatePromises = Object.entries(hardcodedDefaults).map(([colorKey, defaultValue]) =>
        axiosPrivate.put('/school/update', {
          field: colorKey,
          value: defaultValue,
          school_id: school.school_id,
        })
      );

      await Promise.all(updatePromises);

      // Update state + CSS root instantly
      setSchool((prev) => ({
        ...prev,
        ...hardcodedDefaults,
      }));

      Object.entries(hardcodedDefaults).forEach(([key, value]) => {
        document.documentElement.style.setProperty(`--${key}`, value);
      });

      // console.log('✅ All colors reset to default.');
    } catch (err) {
      console.error('❌ Failed to reset all colors:', err);
    } finally {
      setSaving(false);
    }
  };



  const [editingField, setEditingField] = useState(null); // e.g., 'homepage_text'
  const [editValues, setEditValues] = useState({
    homepage_text: '',
    tagline: '',
    student_email: '',
    facebook_url: '',
    instagram_url: '',
    phone_number: '',
    website_url: '',
  });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const handleEdit = (field) => {
    setEditingField(field);
    setEditValues((prev) => ({
      ...prev,
      [field]: school[field] || '',
    }));
    setErrors((prev) => ({ ...prev, [field]: null }));
  };

  const handleChange = (field, value) => {
    setEditValues((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: null }));
  };

  const validateField = (field, value) => {
    switch (field) {
      case 'student_email':
        return /^\S+@\S+\.\S+$/.test(value) ? null : t('homeAdmin.invalidEmail');
      case 'phone_number':
        return /^[+\d\s-]*$/.test(value) ? null : t('homeAdmin.invalidPhone');
      case 'facebook_url':
      case 'instagram_url':
      case 'website_url':
        return /^(https?:\/\/)/.test(value) ? null : t('homeAdmin.invalidWebURL');
      default:
        return null; // no validation for text fields
    }
  };

  const handleSave = async (field) => {
    const error = validateField(field, editValues[field]);
    if (error) {
      setErrors((prev) => ({ ...prev, [field]: error }));
      return;
    }

    try {
      setSaving(true);
      const payload = {
        field,
        value: editValues[field],
        school_id: school.school_id,
        dnzify_url: school.dnzify_url
      };

      const response = await axiosPrivate.put('/school/update', payload);
      setSchool((prev) => ({ ...prev, [field]: editValues[field] }));
      setEditingField(null);
    } catch (err) {
      console.error('Error updating field:', err);
      setErrors((prev) => ({ ...prev, [field]: 'Failed to save changes' }));
    } finally {
      setSaving(false);
    }
  };






  useEffect(() => {
    if (!backendUrl) return;

    const fetchSchoolData = async () => {
      setLoading(true);
      try {
        const response = await axiosPrivate.get('/school/admin');
        const schoolData = response.data[0] || null;
        setSchool(schoolData);

        if (!schoolData) return;

        // Fetch latest media
        const fetchLatestMedia = async (type) => {
          try {
            const res = await axiosPrivate.get(`/school/home/${type}/latest`);
            return res.data?.url ? `${backendUrl}${res.data.url}?t=${Date.now()}` : null;
          } catch (err) {
            console.error(`Error fetching latest ${type}:`, err);
            return null;
          }
        };

        const [logo, video, image] = await Promise.all([
          fetchLatestMedia('logo'),
          fetchLatestMedia('video'),
          fetchLatestMedia('image'),
        ]);

        setLogoUrl(logo);
        setVideoUrl(video);
        setImageUrl(image);

      } catch (err) {
        console.error('Error fetching school data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSchoolData();
  }, [backendUrl]);





  useEffect(() => {
    if (!school) return;

    const colorFields = Object.keys(school).filter(key => key.startsWith('color_'));
    colorFields.forEach(colorKey => {
      const colorValue = school[colorKey];
      if (colorValue) {
        document.documentElement.style.setProperty(`--${colorKey}`, colorValue);
      }
    });
  }, [school]);


  const fieldsWithEdit = [
    'school_name',
    'director_name',
    'homepage_text',
    'tagline',
    'admin_email',
    'student_email',
    'facebook_url',
    'instagram_url',
    'phone_number',
    'website_url',
  ];


  const handleSaveMedia = async () => {
    if (!selectedMediaFile || !school) return;

    try {
      const formData = new FormData();
      formData.append('mediaType', mediaType);
      formData.append('dnzify_url', school.dnzify_url);
      formData.append('file', selectedMediaFile);

      const response = await axiosPrivate.post('/school/upload-media', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      // console.log('Upload success:', response.data);

      const newUrl = `${backendUrl}${response.data.path}`;
      if (mediaType === 'logo') setLogoUrl(newUrl);
      else if (mediaType === 'image') setImageUrl(newUrl);
      else if (mediaType === 'video') setVideoUrl(newUrl);

      setMediaModalVisible(false);
    } catch (err) {
      console.error('Error uploading media:', err);

      if (err.response && err.response.status === 400) {
        const serverMessage = err.response.data?.error || '';

        console.log('err.response.data', err.response.data)
        console.log('serverMessage', serverMessage)

        if (serverMessage.toLowerCase().includes('File is too large')) {
          setMediaError(t('homeAdmin.error.fileTooLarge'));
        } else {
          setMediaError(serverMessage || t('homeAdmin.error.failedUpload'));
        }
      } else {
        setMediaError(t('homeAdmin.error.failedUpload'));
      }
    }
  };




  const colorFields = school ? Object.keys(school).filter((key) => key.startsWith('color_')) : [];


  // Cache-busting: append timestamp so browser fetches latest
  const cacheBustedLogo = logoUrl ? `${logoUrl}?t=${Date.now()}` : null;
  const cacheBustedVideo = videoUrl ? `${videoUrl}?t=${Date.now()}` : null;
  const cacheBustedImage = imageUrl ? `${imageUrl}?t=${Date.now()}` : null;


  return (
    <div className={`${isNavOpen ? 'body-squeezed' : 'body'}`}>

      {loading ? (
        <LoadingSpinner />
      ) : school ? (
        <div className="homeAdmin_container tx1">
          {/* Top heading */}
          <h2 className="homeAdmin_heading">
            {t('homeAdmin.schoolData')}
          </h2>

          {fieldsWithEdit.map((field) => (
            <div key={field} className="homeAdmin_row">
              <span className="homeAdmin_label">{t(`homeAdmin.fields.${field}`)}</span>

              {editingField === field ? (
                <>
                  {field === 'homepage_text' || field === 'tagline' ? (
                    <textarea
                      value={editValues[field]}
                      onChange={(e) => handleChange(field, e.target.value)}
                    />
                  ) : (
                    <input
                      type={field.includes('email') ? 'email' : 'text'}
                      value={editValues[field]}
                      onChange={(e) => handleChange(field, e.target.value)}
                    />
                  )}
                  <button onClick={() => handleSave(field)} disabled={saving}>{t('homeAdmin.save')}</button>
                  <button onClick={() => setEditingField(null)}>{t('homeAdmin.cancel')}</button>
                  {errors[field] && <span className="error">{errors[field]}</span>}
                </>
              ) : (
                <>
                  {(field === 'facebook_url' || field === 'instagram_url') && school[field] ? (
                    <a
                      href={school[field]}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="homeAdmin_socialLink"
                    >
                      {field === 'facebook_url' ? (
                        <>
                          <FontAwesomeIcon icon={faFacebook} /> {school.facebook_url}
                        </>
                      ) : (
                        <>
                          <FontAwesomeIcon icon={faInstagram} /> {school.instagram_url}
                        </>
                      )}
                    </a>
                  ) : (
                    <span>{school[field] || '—'}</span>
                  )}

                  {isAdmin &&
                    ['homepage_text', 'tagline', 'student_email', 'facebook_url', 'instagram_url', 'phone_number', 'website_url'].includes(field) && (
                      (isTestUser || !canEditSchool) ? (
                        blockedAction === `edit-${field}` ? (
                          <DemoBlockedMessage
                            message={t('profile.testPurposesCannotModifyAccount')}
                            onClose={() => setBlockedAction(null)}
                          />
                        ) : (
                          <FontAwesomeIcon
                            icon={faEdit}
                            className="homeAdmin_editIcon"
                            onClick={() => setBlockedAction(`edit-${field}`)}
                          />
                        )
                      ) : (
                        <FontAwesomeIcon
                          icon={faEdit}
                          className="homeAdmin_editIcon"
                          onClick={() => handleEdit(field)}
                        />
                      )
                    )}

                </>
              )}
            </div>
          ))}
          {/* {console.log('subscriptionData', subscriptionsData)} */}

          <div className="homeAdmin_row force-align-center">
            <span className="homeAdmin_label">{t('homeAdmin.subscriptionLevel')}</span>

            <div className="homeAdmin_valueWithButton">
              <span>
                {t(
                  `adminSubscription.${subscriptionsData?.find(sub => sub.id === school.subscription_id)?.subscription_name}`
                  || 'N/A'
                )}
              </span>
              <button className='button-white' style={{ minWidth: "200px" }}>

                <Link to="/admin/adminsubscription">{t('homeAdmin.exploreSubscriptions')}</Link>
              </button>
            </div>
          </div>
          <div className="homeAdmin_row">
            <span className="homeAdmin_label">{t('homeAdmin.dnzifyURL')}</span>
            <span>{`https://www.${school.dnzify_url}.dnzify.com`}</span>
          </div>

          {/* Media sections */}

          {/* Logo */}
          <div className="homeAdmin_row">
            <span className="homeAdmin_label">{t('homeAdmin.logo')}</span>
            {!mediaModalVisible || mediaType !== 'logo' ? (
              logoUrl ? (
                <img
                  src={cacheBustedLogo}
                  alt="School Logo"
                  className="homeAdmin_mediaPreview"
                />
              ) : (
                <span className="homeAdmin_emptyLabel">(empty)</span>
              )
            ) : null}
            {isAdmin && (!mediaModalVisible || mediaType !== 'logo') && (
              <>
                {/* EDIT LOGO */}
                {(isTestUser || !canEditSchool) ? (
                  blockedAction === 'edit-logo' ? (
                    <DemoBlockedMessage
                      message={t('profile.testPurposesCannotModifyAccount')}
                      onClose={() => setBlockedAction(null)}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="homeAdmin_editIcon"
                      onClick={() => setBlockedAction('edit-logo')}
                    />
                  )
                ) : (
                  <FontAwesomeIcon
                    icon={faEdit}
                    className="homeAdmin_editIcon"
                    onClick={() => handleMediaClick('logo')}
                  />
                )}

                {/* DELETE LOGO */}
                {(isTestUser || !canEditSchool) ? (
                  blockedAction === 'delete-logo' ? (
                    <DemoBlockedMessage
                      message={t('profile.testPurposesCannotModifyAccount')}
                      onClose={() => setBlockedAction(null)}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faTrash}
                      className="homeAdmin_deleteIcon"
                      style={{ marginLeft: '10px', color: 'crimson', cursor: 'pointer' }}
                      onClick={() => setBlockedAction('delete-logo')}
                    />
                  )
                ) : (
                  <FontAwesomeIcon
                    icon={faTrash}
                    className="homeAdmin_deleteIcon"
                    style={{ marginLeft: '10px', color: 'crimson', cursor: 'pointer' }}
                    onClick={() => handleDeleteMedia('logo')}
                  />
                )}
              </>
            )}


            {
              mediaModalVisible && mediaType === 'logo' && (
                <div className="media-modal">

                  <div
                    onDrop={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleMediaFileChange({ target: { files: e.dataTransfer.files } });
                    }}

                    onDragOver={(e) => e.preventDefault()}
                    style={{
                      border: '2px dashed #ccc',
                      padding: '20px',
                      borderRadius: '8px',
                      textAlign: 'center',
                      cursor: 'pointer',
                      backgroundColor: '#fafafa',
                      marginBottom: '1rem',
                    }}
                  >
                    <p>{t('homeAdmin.dragAndDrop')}</p>
                    <input
                      type="file"
                      onChange={handleMediaFileChange}
                      style={{ display: 'none' }}
                      id={`media-input-${mediaType}`}
                    />
                    <label htmlFor={`media-input-${mediaType}`} style={{ cursor: 'pointer', color: '#007bff' }}>
                      {t('homeAdmin.orClick')}
                    </label>
                  </div>

                  {mediaPreviewUrl && (
                    mediaType === 'video' ?
                      <video src={mediaPreviewUrl} controls style={{ maxWidth: '100%' }} /> :
                      <img src={mediaPreviewUrl} alt="preview" style={{ maxWidth: '100%' }} />
                  )}

                  {mediaError && <div className="error">{mediaError}</div>}

                  <div className="media-actions">
                    <button
                      className="btn-cancel"
                      onClick={() => setMediaModalVisible(false)}
                    >
                      {t('homeAdmin.cancel')}
                    </button>

                    <button
                      className="btn-save"
                      onClick={handleSaveMedia}
                      disabled={!selectedMediaFile || !!mediaError}
                    >
                      {t('homeAdmin.save')}
                    </button>
                  </div>



                </div>
              )
            }

          </div>

          {/* Video */}
          <div className="homeAdmin_row">
            <span className="homeAdmin_label">{t('homeAdmin.video')}</span>


            {!mediaModalVisible || mediaType !== 'video' ? (
              videoUrl ? (
                <video
                  src={cacheBustedVideo}
                  controls
                  className="homeAdmin_mediaPreview"
                />
              ) : (
                <span className="homeAdmin_emptyLabel">(empty)</span>
              )
            ) : null}


            {isAdmin && (!mediaModalVisible || mediaType !== 'video') && (
              <>
                {/* EDIT VIDEO */}
                {(isTestUser || !canEditSchool) ? (
                  blockedAction === 'edit-video' ? (
                    <DemoBlockedMessage
                      message={t('profile.testPurposesCannotModifyAccount')}
                      onClose={() => setBlockedAction(null)}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="homeAdmin_editIcon"
                      onClick={() => setBlockedAction('edit-video')}
                    />
                  )
                ) : (
                  <FontAwesomeIcon
                    icon={faEdit}
                    className="homeAdmin_editIcon"
                    onClick={() => handleMediaClick('video')}
                  />
                )}

                {/* DELETE VIDEO */}
                {(isTestUser || !canEditSchool) ? (
                  blockedAction === 'delete-video' ? (
                    <DemoBlockedMessage
                      message={t('profile.testPurposesCannotModifyAccount')}
                      onClose={() => setBlockedAction(null)}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faTrash}
                      className="homeAdmin_deleteIcon"
                      style={{ marginLeft: '10px', color: 'crimson', cursor: 'pointer' }}
                      onClick={() => setBlockedAction('delete-video')}
                    />
                  )
                ) : (
                  <FontAwesomeIcon
                    icon={faTrash}
                    className="homeAdmin_deleteIcon"
                    style={{ marginLeft: '10px', color: 'crimson', cursor: 'pointer' }}
                    onClick={() => handleDeleteMedia('video')}
                  />
                )}
              </>
            )}

            {
              mediaModalVisible && mediaType === 'video' && (
                <div className="media-modal">

                  <div
                    onDrop={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleMediaFileChange({ target: { files: e.dataTransfer.files } });
                    }}

                    onDragOver={(e) => e.preventDefault()}
                    style={{
                      border: '2px dashed #ccc',
                      padding: '20px',
                      borderRadius: '8px',
                      textAlign: 'center',
                      cursor: 'pointer',
                      backgroundColor: '#fafafa',
                      marginBottom: '1rem',
                    }}
                  >
                    <p>{t('homeAdmin.dragAndDrop')}</p>
                    <input
                      type="file"
                      onChange={handleMediaFileChange}
                      style={{ display: 'none' }}
                      id={`media-input-${mediaType}`}
                    />
                    <label htmlFor={`media-input-${mediaType}`} style={{ cursor: 'pointer', color: '#007bff' }}>
                      {t('homeAdmin.orClick')}
                    </label>
                  </div>

                  {mediaPreviewUrl && (
                    mediaType === 'video' ?
                      <video src={mediaPreviewUrl} controls style={{ maxWidth: '100%' }} /> :
                      <img src={mediaPreviewUrl} alt="preview" style={{ maxWidth: '100%' }} />
                  )}

                  {mediaError && <div className="error">{mediaError}</div>}

                  <div className="media-actions">
                    <button
                      className="btn-cancel"
                      onClick={() => setMediaModalVisible(false)}
                    >
                      {t('homeAdmin.cancel')}
                    </button>

                    <button
                      className="btn-save"
                      onClick={handleSaveMedia}
                      disabled={!selectedMediaFile || !!mediaError}
                    >
                      {t('homeAdmin.save')}
                    </button>
                  </div>


                </div>
              )
            }

          </div>

          {/* Image */}
          <div className="homeAdmin_row">
            <span className="homeAdmin_label">{t('homeAdmin.image')}</span>
            {!mediaModalVisible || mediaType !== 'image' ? (
              imageUrl ? (
                <img
                  src={cacheBustedImage}
                  alt="School Image"
                  className="homeAdmin_mediaPreview"
                />
              ) : (
                <span className="homeAdmin_emptyLabel">(empty)</span>
              )
            ) : null}
            {isAdmin && (!mediaModalVisible || mediaType !== 'image') && (
              <>
                {/* EDIT IMAGE */}
                {(isTestUser || !canEditSchool) ? (
                  blockedAction === 'edit-image' ? (
                    <DemoBlockedMessage
                      message={t('profile.testPurposesCannotModifyAccount')}
                      onClose={() => setBlockedAction(null)}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="homeAdmin_editIcon"
                      onClick={() => setBlockedAction('edit-image')}
                    />
                  )
                ) : (
                  <FontAwesomeIcon
                    icon={faEdit}
                    className="homeAdmin_editIcon"
                    onClick={() => handleMediaClick('image')}
                  />
                )}

                {/* DELETE IMAGE */}
                {(isTestUser || !canEditSchool) ? (
                  blockedAction === 'delete-image' ? (
                    <DemoBlockedMessage
                      message={t('profile.testPurposesCannotModifyAccount')}
                      onClose={() => setBlockedAction(null)}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faTrash}
                      className="homeAdmin_deleteIcon"
                      style={{ marginLeft: '10px', color: 'crimson', cursor: 'pointer' }}
                      onClick={() => setBlockedAction('delete-image')}
                    />
                  )
                ) : (
                  <FontAwesomeIcon
                    icon={faTrash}
                    className="homeAdmin_deleteIcon"
                    style={{ marginLeft: '10px', color: 'crimson', cursor: 'pointer' }}
                    onClick={() => handleDeleteMedia('image')}
                  />
                )}
              </>
            )}


            {
              mediaModalVisible && mediaType === 'image' && (
                <div className="media-modal">

                  <div
                    onDrop={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleMediaFileChange({ target: { files: e.dataTransfer.files } });
                    }}

                    onDragOver={(e) => e.preventDefault()}
                    style={{
                      border: '2px dashed #ccc',
                      padding: '20px',
                      borderRadius: '8px',
                      textAlign: 'center',
                      cursor: 'pointer',
                      backgroundColor: '#fafafa',
                      marginBottom: '1rem',
                    }}
                  >
                    <p>{t('homeAdmin.dragAndDrop')}</p>
                    <input
                      type="file"
                      onChange={handleMediaFileChange}
                      style={{ display: 'none' }}
                      id={`media-input-${mediaType}`}
                    />
                    <label htmlFor={`media-input-${mediaType}`} style={{ cursor: 'pointer', color: '#007bff' }}>
                      {t('homeAdmin.orClick')}
                    </label>
                  </div>

                  {mediaPreviewUrl && (
                    mediaType === 'video' ?
                      <video src={mediaPreviewUrl} controls style={{ maxWidth: '100%' }} /> :
                      <img src={mediaPreviewUrl} alt="preview" style={{ maxWidth: '100%' }} />
                  )}

                  {mediaError && <div className="error">{mediaError}</div>}

                  <div className="media-actions">
                    <button
                      className="btn-cancel"
                      onClick={() => setMediaModalVisible(false)}
                    >
                      {t('homeAdmin.cancel')}
                    </button>

                    <button
                      className="btn-save"
                      onClick={handleSaveMedia}
                      disabled={!selectedMediaFile || !!mediaError}
                    >
                      {t('homeAdmin.save')}
                    </button>
                  </div>


                </div>
              )
            }

          </div>


          {/* Reset all colors */}
          {isAdmin && (
            <div className="homeAdmin_row" style={{ marginBottom: '2em' }}>
              {(isTestUser || !canEditSchool) ? (
                blockedAction === 'reset-colors' ? (
                  <DemoBlockedMessage
                    message={t('profile.testPurposesCannotModifyAccount')}
                    onClose={() => setBlockedAction(null)}
                  />
                ) : (
                  <button
                    className="button-red"
                    style={{ minWidth: '250px' }}
                    onClick={() => setBlockedAction('reset-colors')}
                  >
                    {t('homeAdmin.resetAllColors')}
                  </button>
                )
              ) : (
                <button
                  className="button-red"
                  onClick={handleResetAllColors}
                  disabled={saving}
                  style={{ minWidth: '250px' }}
                >
                  {saving ? t('homeAdmin.resettingColors') : t('homeAdmin.resetAllColors')}
                </button>
              )}
            </div>
          )}




          {/* Color swatches */}
          {colorFields.map((color) => {
            const currentColor = school[color];
            const defaultColor = school[`default_${color}`];
            const isDefault = currentColor?.toLowerCase() === defaultColor?.toLowerCase();

            // Add your descriptions here — match by key name if you like
            const colorDescriptions = {
              color_0: t('homeAdmin.colors.color0'),
              color_1: t('homeAdmin.colors.color1'),
              color_2: t('homeAdmin.colors.color2'),
              color_3: t('homeAdmin.colors.color3'),
              color_6: t('homeAdmin.colors.color6'),
              color_7: t('homeAdmin.colors.color7'),
              color_9: t('homeAdmin.colors.color9'),
              color_10: t('homeAdmin.colors.color10'),
              color_11: t('homeAdmin.colors.color11'),
              color_12: t('homeAdmin.colors.color12'),
              color_13: t('homeAdmin.colors.color13'),
              color_14: t('homeAdmin.colors.color14'),
              color_100: t('homeAdmin.colors.color100'),
              color_200: t('homeAdmin.colors.color200'),
              color_201: t('homeAdmin.colors.color201'),
              color_202: t('homeAdmin.colors.color202'),
              color_203: t('homeAdmin.colors.color203'),
              color_300: t('homeAdmin.colors.color300'),
              color_301: t('homeAdmin.colors.color301'),
              color_302: t('homeAdmin.colors.color302'),
              color_400: t('homeAdmin.colors.color400'),
              color_401: t('homeAdmin.colors.color401'),
              color_500: t('homeAdmin.colors.color500')
            };


            return (
              <div key={color} className="homeAdmin_row_colorWrapper">
                <div className="homeAdmin_row_color">
                  <span className="homeAdmin_label">{color}:</span>

                  {(isTestUser || !canEditSchool) ? (
                    blockedAction === `color-${color}` || blockedAction === `reset-color-${color}` ? (
                      <DemoBlockedMessage
                        message={t('profile.testPurposesCannotModifyAccount')}
                        onClose={() => setBlockedAction(null)}
                      />
                    ) : (
                      <>
                        <input
                          type="color"
                          value={currentColor}
                          disabled
                          style={{ cursor: 'not-allowed', opacity: 0.6 }}
                          onClick={() => setBlockedAction(`color-${color}`)}
                        />

                        <FontAwesomeIcon
                          icon={faRotateLeft}
                          className="homeAdmin_resetIcon inactive"
                          style={{ cursor: 'not-allowed', opacity: 0.5 }}
                          onClick={() => setBlockedAction(`reset-color-${color}`)}
                        />
                      </>
                    )
                  ) : (
                    <>
                      <input
                        type="color"
                        value={currentColor}
                        onChange={(e) => handleColorChange(color, e.target.value)}
                      />

                      {isAdmin && (
                        <FontAwesomeIcon
                          icon={faRotateLeft}
                          className={`homeAdmin_resetIcon ${isDefault ? 'inactive' : ''}`}
                          onClick={() => handleResetColor(color)}
                        />
                      )}
                    </>
                  )}

                </div>
                <div className="homeAdmin_colorDescription">
                  {colorDescriptions[color] || t('homeAdmin.color.colorNotDocumented')}
                </div>
              </div>
            );
          })}









        </div>

      ) :
        (<Error />)
      }




    </div>
  );


}
